module.exports = __webpack_public_path__ + "images/7387d7b6007844c21288305812d925ff-playpause.svg";